import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.js";
import $ from "../$.js";

export {init}
Html.registerWidget('widget/minimap',{init:init})

var
  // list of location of family members
memberLocations = null,

// index of family member currently selected in list of member locations
selectedMemberIndex = 0,

// parent container
container = null;

function display(){
  import("../widget/minimap.mustache").then(function(TPL){
    var location = memberLocations[selectedMemberIndex % memberLocations.length];
    //this stuff is for sprint using full marker and not just marker_noplace
    if(location){
      location.locations = location;  
    }
    Html.setHtml(container,TPL,{
      location: location,
      navigation: memberLocations.length>1
    });  
  });
}

Html.register({
  minimap:function(delta){
    selectedMemberIndex += memberLocations.length + parseInt(delta,10);
    display();
  }
});
function init(obj){
  container = obj;
  if(container.is(':visible')) {
    ApiServer.locgetpositions2(function(data){
      memberLocations = $.grep(data,function(location,idx){
        return location.mapURI!==null;
      });
      display();
    });
    
  }
}